<template>
  <div>
    <v-app>
      <v-container>
        <!-- タイトル -->
        <v-row justify="center">
          <v-col cols="auto" class="text-h6 pb-0">{{ title }} </v-col>
        </v-row>

        <!-- エラー画像 -->
        <v-row justify="center" class="mt-8 mb-8">
          <v-img max-width="120" :src="iconUrl"></v-img>
        </v-row>

        <!-- テキスト -->
        <v-row align="center" justify="center" class="mt-4 pl-4 pr-4">
          <v-col cols="auto"
            ><span class="pre-wrap text-body-1" v-text="text"></span
          ></v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { mapActions } from "vuex";
const IMAGE_SORRY = require("@/assets/sorry.png");

export default {
  data: () => ({
    errorNo: "",
    orderNo: "",

    // アイコン
    iconUrl: IMAGE_SORRY,
    title: "",
    text: "このサービスは LINE アプリ専用です",
  }),
  created() {
    this.$store.state.appBar = false;
    this.$store.state.title = "エラー";
    this.$store.state.cart = false;
  },
  mounted() {
    this.hideProgress();
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions(["showProgress", "hideProgress"]),
  },
};
</script>
